import random from 'toxilibs/random.js'

function createQuestion (q, method, params) {
    let {n} = params
    let {word, answer, grams, countedGrams, badChoices} = method(params)

    q.addClass('centered_question')

    q.answer = answer

    q.addText(handleQuestionMarks(word.replaceAll(' ', '  ')))
    q.addText('----- ' + '<span class="scissors_icon"></span>'.repeat(n) + ' -----')


    if (grams.length > 10) {
        let cutAt = Math.ceil(grams.length / 2) + 1
        addGrams(q, grams.slice(0, cutAt))
        addGrams(q, grams.slice(cutAt))
    } else {
        addGrams(q, grams)
    }


    if (countedGrams) {
        q.addText('<span class="machine">----- <span class="counter_icon"></span> -----</span>')
        q.addText(
            handleQuestionMarks(countedGrams.map(x => x[0] + ':' + x[1]).join(', '))
        )
    }

    q.addBadChoices(...badChoices)
}



function addGrams (q, grams) {
    q.addText(handleQuestionMarks(grams.join(', ')))
}




function cutAndMysteryLetter ({word, n, pos = false}) {
    let grams = computeGrams({word, n})

    while (pos === false) {
        pos = random.intBetween(2, word.length - 2)
        if (word[pos] === ' ') {
            pos = false
        }
    }

    let answer = word[pos]
    let badChoices = word.replaceAll(' ', '').split('')

    word = word.slice(0, pos) + '?' + word.slice(pos + 1)

    return {word, grams, answer, badChoices}
}


function cutAndMysteryGram ({word, n, pos = false}) {
    let grams = computeGrams({word, n})

    if (pos === false) {
        pos = random.intBetween(2, grams.length - 2)
    }


    let answer = grams[pos]
    let badChoices = [...grams]

    grams[pos] = '?'

    return {word, grams, answer, badChoices}
}


function cutCountAndMysteryCountedGram ({word, n, pos = false}) {
    let grams = computeGrams({word, n})

    let countedGrams = countGrams(grams)

    if (pos === false) {
        pos = random.intBetween(0, countedGrams.length - 1)
    }

    let answer = countedGrams[pos][0]
    let badChoices = countedGrams.map(x => x[0])

    countedGrams[pos][0] = '?'

    return {word, grams, countedGrams, answer, badChoices}
}


function cutCountAndMysteryCount ({word, n, pos = false}) {
    let grams = computeGrams({word, n})

    let countedGrams = countGrams(grams)

    if (pos === false) {
        pos = random.intBetween(0, countedGrams.length - 1)
    }

    let answer = countedGrams[pos][1]
    let badChoices = [...countedGrams.map(x => x[1]), 'digit']

    countedGrams[pos][1] = '?'

    return {word, grams, countedGrams, answer, badChoices}
}


function computeGrams ({word, n}) {
    let parts = word.split(' ')

    let grams = []

    parts.forEach(part => {
        let splitted = part.split('')
        for (let i = 0; i <= splitted.length - n; i++) {
            grams.push(splitted.slice(i, i + n).join(''))
        }
    })

    return grams
}


function countGrams (grams) {
    let counted = {}

    grams.forEach(gram => {
        counted[gram] = (counted[gram] || 0) + 1
    })

    return Object.entries(counted).sort(sortByCountThenAlphabetical)
}


function sortByCountThenAlphabetical (a, b) {
    return (b[1] - a[1]) || a[0].localeCompare(b[0])
}


function handleQuestionMarks (string) {
    return string.replaceAll('?', '<span class="visible_question_mark">?</span>')
}



function realWords () {
    return random.fairChoice([
        'hello help kelp hell',
        'woman man mama roman',
        'when who home whom hen',
        'all calls wall halls call',
        'should could would mould',
        'moons ones bones one'
    ], {name: 'ngrams_realWords'})
}


function easyRealWords () {
    return random.fairChoice([
        'welcome',
        'peace and love',
        'hello mouse',
        'the garden'
    ], {name: 'ngrams_realWords_easy'})
}





export default {
    createQuestion,

    cutAndMysteryGram,
    cutAndMysteryLetter,


    cutCountAndMysteryCount,
    cutCountAndMysteryCountedGram,


    realWords,
    easyRealWords

}

